import {Platform} from "@angular/cdk/platform";
import {PlatformUtils} from "@app/core/shared/domain/platform.utils";
import {Injectable} from "@angular/core";

/*
 * Implements the PlatformUtils interface using Angular CDK's Platform
 * to determine if the application is running on a mobile platform (iOS or Android).
 * This implementation will return true if the app is running on a mobile web platform (iOS or Android).
 */
@Injectable({
    providedIn: 'root'
})
export class PlatformCdk implements PlatformUtils{
    isMobile = this.platform.IOS || this.platform.ANDROID

    constructor(private platform:Platform) { }
}